<div class="category" *ngFor="let category of this.sourceManager.data()">
    <div class="category-title">
        {{category.title}}
    </div>
    <div class="card-list">
        <app-card *ngFor="let source of category.sources" [source]="source"></app-card>
    </div>
</div>
<div class="overflow-fade"></div>

<!-- <pre>
  {{ this.sourceManager.data() | json }}
</pre> -->